import { BusinessChoiceType } from 'features/utils/types';
import { useTranslation } from 'react-i18next';

export default function useTVAText(businessChoice: BusinessChoiceType) {
  const { t } = useTranslation();
  if (businessChoice === 'b2c') {
    return t('common.tvac');
  }
  return t('common.htva');
}
